import React, { useEffect, useState } from "react";
import "./addpartnumber.scss";
import { Iprops } from "./addpartinterface";
import { TreeviewDropdown } from "../../CommonComponent";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { RESOURCE } from "../../../const/resource";
import partsService from "../../../services/partsservice";
import { selectors as globalDataSelector } from "../../../state/features/common/globaldata";
import { selectors as headerSelector } from '../../../state/features/header';
import helperfunctions from "../../../utils/helperfunctions";
import moment from "moment";
import ShoppingCartLoader from "../ShopCartLoader";
import Loader from "../../Loader";

const AddPartNumber = (props: Iprops) => {
    const { t } = useTranslation();
    const { globalData }: any = useSelector((state) => ({
        globalData: globalDataSelector.globaldata(state),
    }));
    const defaultManufacture = props?.manufactureOption?.find((s: any) => s?.title?.toLowerCase() == "komatsu")?.value ?? "";
    let [quantity, setQuantity] = useState<number>(1);
    const [manufacture, setManufacture] = useState<any>(defaultManufacture);
    const [isAddingParts, setIsAddingParts] = useState(false)
    const [partNo, setPartNo] = useState<any>("");
    const { headercurrentuser }: any = useSelector(
        state => ({
            headercurrentuser: headerSelector.currentuser(state),
        })
    );

    const getIsGlobalDataSelected = () => {
        return (globalData?.CustomerId ?? "") != "" && (globalData?.LocationId ?? "") != "" && (globalData?.DistributorCode ?? "") != "";
    }

    useEffect((
    ) => {
        if (props.isPartNumber) {
            setManufacture(defaultManufacture);
            setQuantity(1);
            setPartNo("");
        }
    }, [props.isPartNumber, defaultManufacture])

    const addPartNumber = () => {
        if (!getIsGlobalDataSelected() && !headercurrentuser.isGuestUser) {
            props.setIsPriceAndAvailabilityRequired(true);
        }
        else if (partNo?.trim() == "") {
            helperfunctions.showErrorMessage(t(RESOURCE.MyK_Label_ShoppingCart_Part_Number_Required));
        }
        else if (manufacture == "" || manufacture == null) {
            helperfunctions.showErrorMessage(t(RESOURCE.MyK_Label_ShoppingCart_Manufacture_Required));
        }
        else if (quantity < 1 || quantity > 9999) {
            helperfunctions.showErrorMessage(t(RESOURCE.MyK_Label_ShoppingCart_Quantity_Validation));
        }
        else {
            addPartNumberService();
        }
    }

    const addPartNumberService = () => {
        setIsAddingParts(true);
        const model = {
            cart: {
                PunchoutOrderRequestId: globalData?.punchOutRequestPartLogId ?? 0,
                userAadId: headercurrentuser?.azureADId,
                distributorCode: globalData.DistributorCode,
                branchCode: globalData.BranchCode,
                customerId: globalData.CustomerId ? parseInt(globalData.CustomerId) : 0,
                locationId: globalData.LocationId ? parseInt(globalData.LocationId) : 0,
                isGuest: headercurrentuser?.isGuestUser,
            },
            parts: [
                {
                    manufacturer: {
                        code: manufacture,
                        name: ""
                    },
                    partNumber: partNo.trim(),
                    quantity: quantity,
                    machine: {
                        mDbId: 0
                    }
                }
            ]
        };
        partsService.addPartNumber(model)
            .then((response: any) => {
                setIsAddingParts(false)
                if (response.isSuccessful) {
                    localStorage.setItem("isRefreshedAfterAdd", 'false');
                    props?.setRefreshCartRequiredParts([response?.cartDetailId]);
                    helperfunctions.showSuccessMessage(response?.message ?? t(RESOURCE.MyK_Label_ShoppingCart_Add_Part_Success_Msg));
                    props.getCartItems();
                    setManufacture(defaultManufacture);
                    setPartNo("");
                    setQuantity(1);
                    props?.getMiningParts();
                }
                else
                    helperfunctions.showErrorMessage(response?.message ?? t(RESOURCE.MyK_Label_ShoppingCart_Add_Part_Error_Msg));
            })
            .catch((e: any) => {
                setIsAddingParts(false)
                helperfunctions.showErrorMessage(e);
            });
    }

    const handlePartNoChange = (event: any) => {
        let value = event?.target?.value ?? ''; 
        if (value.includes(',')) {
            value = value.replace(/,/g, '');
        }
        setPartNo(value);
    }

    const getLastRefreshDate = () => {
        let formattedDateTime = "";
        if (props?.cartsDetails?.cart?.cartLastRefreshed != undefined && props?.cartsDetails?.cart?.cartLastRefreshed != '' &&
            moment(props?.cartsDetails?.cart?.cartLastRefreshed).format("MM/DD/YYYY hh:mm:ss") != "01/01/0001 12:00:00") {

            const refreshTime = helperfunctions.DateFormatbasedONRegion(props?.cartsDetails?.cart?.cartLastRefreshed, headercurrentuser?.userpreference?.culture);
            const refeshTimeZone = moment().tz(Intl.DateTimeFormat().resolvedOptions().timeZone).zoneAbbr();
            let onlytimeConversion = moment(props?.cartsDetails?.cart?.cartLastRefreshed ? props?.cartsDetails?.cart?.cartLastRefreshed + 'Z' : props?.cartsDetails?.cart?.cartLastRefreshed).format('hh:mm A');
            formattedDateTime = t(RESOURCE.MyK_Label_ShoppingCart_Cart_Last_Refreshed) + " : " + `${refreshTime} ${onlytimeConversion} ${refeshTimeZone}`;
        }
        return formattedDateTime;
    }

    function incrementCount(e: any) {
        let qty = quantity + 1;
        if (qty <= 9999) {
            setQuantity(qty);
        }
    }
    function decrementCount(e: any) {
        if (quantity === 1) {
            setQuantity(1);
        } else {
            let qty = quantity - 1;
            setQuantity(qty);
        }
    }
    const handleQntChange = (event: any) => {
        const value = event.target.value;
        const regex = /^\d+$/;
        if (value > 9999) {
            setQuantity(9999);
        } else if(regex.test(value) || !value){
            setQuantity(value);
        } else {
            const qty = quantity;
            setQuantity(qty)
        }
    }

    const handleQntOnBlur = (event: any) => {
        const value = parseInt(event.target.value);
        if (value <= 0) {
            setQuantity(1);
        }
        else if (value > 9999) {
            setQuantity(9999);
        }
        else {
            setQuantity(isNaN(value) ? 1 : value);
        }
    }

    return (
        <div
            className={
                props.cartToolMenu
                    ? "add_part-Numbers"
                    : "add_part-Numbers add_parts-enable"
            }
        >
            {isAddingParts && <Loader/>}
            {(props.cartToolMenu && props?.isRefreshing) && <>
                <div className="shopping_cart_Heading">{t(RESOURCE.MyK_Label_ShoppingCart)}</div>
                <div className="scLoader">
                    <ShoppingCartLoader />
                </div>
            </>}
            <div className="addpart_accordian-HD">
                {props.cartToolMenu ? (
                    ""
                ) : (
                    <div className="addPartToggle" onClick={() => props.onHandlePartNo()} onKeyDown={() => { }}>
                        {
                            !props.isPartNumber ? <span className="fa fa-plus add_part-symbol-plus" title={t(RESOURCE.MyK_Label_ShoppingCart_Add)}></span> : <span className="add_part-symbol" title={t(RESOURCE.MyK_Label_ShoppingCart_Promo_Remove)}>-</span>
                        }
                        <span className="add_part-HD" title={t(RESOURCE.MyK_Label_ShoppingCart_Add_Part_Number)}>
                            {t(RESOURCE.MyK_Label_ShoppingCart_Add_Part_Number)}
                        </span>
                    </div>
                )}
                {props.cartToolMenu ? (
                    <div className="headingCartItem">
                        {!props?.isRefreshing &&
                            <div className="shopping_cart_Heading">{t(RESOURCE.MyK_Label_ShoppingCart)}</div>
                        }
                        <div className="item_in-Cart">{props?.cartsDetails?.parts?.length ?? 0} {(props?.cartsDetails?.parts?.length > 1) ? t(RESOURCE.MyK_Label_ShoppingCart_ItemsInCart) : t(RESOURCE.MyK_Label_ShoppingCart_ItemInCart)}</div>
                    </div>
                ) : null}
                {(!props.isPartNumber && props?.cartsDetails?.parts?.length > 0) ? (
                    <div className="refresh-Section">
                        <span className="Cart_Last-refreshed ">
                            {getLastRefreshDate()}
                        </span>
                        <span className="Refresh_Availability" title={t(RESOURCE.MyK_Label_ShoppingCart_Refresh_Cart)} onClick={() => { props?.getAdminFlag(); props.onRefresh(null, true); }} onKeyDown={() => { }}>
                            {t(RESOURCE.MyK_Label_ShoppingCart_Refresh_Cart)}
                        </span>
                    </div>
                ) : null}
                {props.isPartNumber && props?.cartsDetails?.parts?.length > 0 ? (
                    <div className="refresh-Section">
                        <span className="Cart_Last-refreshed Availablity">
                            {getLastRefreshDate()}
                        </span>
                        <span className="Refresh_Availability" title={t(RESOURCE.MyK_Label_ShoppingCart_Refresh_Availability)} onKeyDown={() => { }} onClick={() => { props?.getAdminFlag(); props.onRefresh(null, true); }}>{t(RESOURCE.MyK_Label_ShoppingCart_Refresh_Availability)}</span>
                    </div>) : null
                }
            </div>
            {!props.cartToolMenu && props.isPartNumber ? (
                <div className="addpart_accordian-Content">
                    <div className="addpart_accordian-Content-left">
                        <span className="partsNumberWrapper">
                            <label className="addpart_label mr-3">{t(RESOURCE.MyK_Label_ShoppingCart_Part)}#</label>
                            <input maxLength={50} className="parts_input" value={partNo} onChange={handlePartNoChange}></input>
                        </span>
                        <span className="manufacturer_wrapper">
                            <label className="addpart_label mr-3">{t(RESOURCE.MyK_Label_ShoppingCart_Manufacturer)}</label>
                            <div className="manufacture-ddl">
                                <TreeviewDropdown
                                    treeData={props?.manufactureOption}
                                    showSearch={true}
                                    value={manufacture}
                                    treeNodeFilterProp={"title"}
                                    onChange={(value: any) => { setManufacture(value) }}
                                />
                            </div>
                        </span>
                        <span className="mx-0 ml-md-0 ml-lg-0 mx-xl-2 addPartsQuantity">
                            <label className="addpart_label mr-3">{t(RESOURCE.MyK_Label_ShoppingCart_Qty)}</label>
                            <div className="quantity-value dropshipQuantity">
                                <span title={t(RESOURCE.MyK_Label_SC_Partlist_Decrease)} className="quantity_minus" onClick={decrementCount} onKeyDown={() => { }}>-</span>
                                <span><input type="text" className="textfield" onBlur={handleQntOnBlur} onChange={handleQntChange} value={quantity}></input></span>
                                <span title={t(RESOURCE.MyK_Label_SC_Partlist_Increase)} className="quantity_plus" onClick={incrementCount} onKeyDown={() => { }}>+</span> 
                            </div>
                            {/* <input type="number" value={quantity} max={9999} min={1} onChange={handleQntChange} className="qty_input mx-0 ml-md-0 ml-lg-3 mx-sm-3"></input> */}
                        </span>

                    </div>
                    <div className="addpart_accordian-Content-right">
                        <button className="custom_lineBtn" onClick={addPartNumber} title={t(RESOURCE.MyK_Label_ShoppingCart_Add)}>{t(RESOURCE.MyK_Label_ShoppingCart_Add)}</button>
                    </div>
                </div>
            ) : null}
        </div>
    );
};

export default AddPartNumber;
